import { useEffect, useState } from 'react'
import { getToken, removeToken, api, salirGo } from './api'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Parcelas from './pages/Parcelas'
import CuadernoCampo from './pages/CuadernoCampo'
import Cultivos from './pages/Cultivos'
import Inventario from './pages/Inventario'
import Costes from './pages/Costes'
import Jornales from './pages/Jornales'
import Usuarios from './pages/Usuarios'
import Configuracion from './pages/Configuracion'
import Riegos from './pages/Riegos'
import Servicios from './pages/Servicios'
import Tratamientos from './pages/Tratamientos'
import Trabajadores from './pages/Trabajadores'
import MiPerfil from './pages/MiPerfil'

export default function App() {
  const [usuario, setUsuario] = useState(null)
  const [cargando, setCargando] = useState(true)
  const [pagina, setPagina] = useState('dashboard')

  useEffect(() => {
    const token = getToken()
    if (token) {
      api('/auth/me')
        .then(data => setUsuario(data))
        .catch(() => removeToken())
        .finally(() => setCargando(false))
    } else {
      setCargando(false)
    }
  }, [])

  const handleLogin = (token, usuario) => {
    setUsuario(usuario)
  }

  const handleLogout = () => {
    if (usuario?.en_go) { salirGo(); return }
    removeToken()
    setUsuario(null)
    setPagina('dashboard')
  }

  if (cargando) return (
    <div style={{ minHeight: '100vh', background: '#1B3A6B', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: 'white', fontSize: '16px' }}>Cargando...</div>
    </div>
  )

  if (!usuario) return <Login onLogin={handleLogin} />

  const navBar = pagina !== 'dashboard' && (
    <div style={{ background: '#1B3A6B', padding: '10px 16px', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => setPagina('dashboard')}>
      <span style={{ color: 'white', fontSize: '18px' }}>←</span>
      <span style={{ color: 'white', fontSize: '13px' }}>Inicio</span>
    </div>
  )

  // GO!: el administrador está viendo la app como otra persona
  const bandaGo = usuario.en_go && (
    <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#ef9f27', color: '#fff', padding: '8px 12px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', flexWrap: 'wrap', fontSize: '13px', fontWeight: 600 }}>
      <span>GO! · Viendo como {usuario.nombre}. No puedes firmar por él y lo que abras no cuenta como visto.</span>
      <button onClick={salirGo} style={{ background: '#fff', color: '#854f0b', border: 'none', borderRadius: '6px', padding: '4px 12px', fontWeight: 700, cursor: 'pointer' }}>
        Volver a mi usuario
      </button>
    </div>
  )

  return (
    <div>
      {bandaGo}
      {pagina === 'dashboard' && <Dashboard usuario={usuario} onLogout={handleLogout} onNavegar={setPagina} />}
      {pagina === 'parcelas' && <>{navBar}<Parcelas usuario={usuario} /></>}
      {pagina === 'cuaderno' && <>{navBar}<CuadernoCampo /></>}
      {pagina === 'cultivos' && <>{navBar}<Cultivos usuario={usuario} /></>}
      {pagina === 'inventario' && <>{navBar}<Inventario usuario={usuario} /></>}
      {pagina === 'costes' && <>{navBar}<Costes /></>}
      {pagina === 'jornales' && <>{navBar}<Jornales /></>}
      {pagina === 'riegos' && <>{navBar}<Riegos usuario={usuario} /></>}
      {pagina === 'servicios' && <>{navBar}<Servicios /></>}
      {pagina === 'tratamientos' && <>{navBar}<Tratamientos usuario={usuario} /></>}
      {pagina === 'trabajadores' && <>{navBar}<Trabajadores /></>}
      {pagina === 'miperfil' && <>{navBar}<MiPerfil /></>}
      {pagina === 'usuarios' && <>{navBar}<Usuarios /></>}
      {pagina === 'configuracion' && <>{navBar}<Configuracion /></>}
    </div>
  )
}
